import React from 'react';
import { graphql } from 'gatsby';
import { Grid } from 'semantic-ui-react';
import Helmet from 'react-helmet';
import { PageLayout, CardNavigation, HeroElement, About,  } from '@fishrmn/fishrmn-components';




import Layout from '../components/Layout';

export default class extends React.PureComponent {

  render() {
    const businessData = this.props.data.allFisherman.edges[0].node;
    const imageData = this.props.data.allFishermanImages.edges[0].node;
    const data = { ...businessData, ...imageData };

    return (
      <Layout>
        <Helmet>
          <title>{data.businessName} | Order Online</title>
          <meta name="description" content="" />
        </Helmet>
        <PageLayout
          hero={ 
              <HeroElement
                header={ "Order Online" }
                tagline={ "" }
                images={ [ data.heroImages.map( ({url}) => url)[1] ] }
                showMap={ false }
                ctas={ [  ] }
                ctaInverted={ true }
                ctaColor={ "white" }
                containerColor={ "primary" }
                textColor={ "white" }
                showMultiple={ true }
                overlay={ true }
                fullWidth={ true }
                parallax={ true }
                containerAs={ "none" }
                height={ "100vh" }
                gutter={ false }
              />
           }
        >
          <Grid
            stackable
            className="component-section-container"
            verticalAlign={ "middle" }
            textAlign={ "center" }
          >
            <Grid.Column width={ 12 }>
              <About
                content={ 'Please check back soon to order online.' }
                header={ 'Online Order - Coming Soon!' }
                centerContent={ true }
                headerAs={ "h1" }
                withContainer={ true }
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    allFisherman {
      edges {
        node {
          businessName 
          about 
        }
      }
    }
    allFishermanImages {
      edges {
        node {
          galleryImages {
            url 
          }
          heroImages {
            url 
          }
        }
      }
    }
  }
`;